import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OpenIncidentController } from '@shared/src/controllers/open/openincident.controller';
import { RouteCMRAgents, RouteCMRAgentsEnum } from '@shared/src/controllers/route/cmr/RouteCMRAgents';
import { HString } from '@shared/src/datatypes/HString';
import { IncidentStateDto } from '@shared/src/dtos/incident/IncidentStateDto';

/**
 * Accions que es mostren sota la firma d'un agent extern: informar d'un problema, afegir un comentari i, si el
 * conductor està parat, indicar que ja està arreglat. Només notifica el clic; el component pare decideix com
 * mostrar el formulari corresponent
 */
@Component({
    selector: 'shared-external-cmr-agent-phase-signactions',
    templateUrl: './shared.external.cmr.agent.phase.signactions.component.html',
    styleUrls: ['./shared.external.cmr.agent.phase.signactions.component.scss']
})
export class SharedExternalCMRAgentPhaseSignActionsComponent {

    constructor(private openIncidentController: OpenIncidentController) {
    }

    private phaseUUIDValue: string;
    @Input()
    public set phaseUUID(value: string) {
        if (this.phaseUUIDValue === value)
            return;
        this.phaseUUIDValue = value;
        this.loadData();
    }
    public get phaseUUID(): string {
        return this.phaseUUIDValue;
    }

    private agentValue: RouteCMRAgents;
    @Input()
    public set agent(value: RouteCMRAgents) {
        if (this.agentValue === value)
            return;
        this.agentValue = value;
        this.loadData();
    }
    public get agent(): RouteCMRAgents {
        return this.agentValue;
    }

    @Output() public reportProblem: EventEmitter<boolean> = new EventEmitter();
    @Output() public addComment: EventEmitter<boolean> = new EventEmitter();
    @Output() public resolveStandStill: EventEmitter<boolean> = new EventEmitter();

    public state: IncidentStateDto;

    /** Recarrega l'estat (per exemple, en tornar d'informar d'un problema o d'estic parat) */
    public loadData(): void {
        if (HString.isNullOrNullString(this.phaseUUID) || !RouteCMRAgentsEnum.isValid(this.agent))
            return;
        this.openIncidentController.getIncidentState(this.phaseUUID, null, this.agent).subscribe(data => {
            this.state = data;
        });
    }

    /** Des de la firma poden informar d'un problema el conductor i el consignatari */
    public canReport(): boolean {
        return this.state != null && this.state.canReport;
    }

    public isStandStill(): boolean {
        return this.state != null && this.state.iStandStill;
    }

    public onReportProblem(): void {
        this.reportProblem.next(true);
    }

    public onAddComment(): void {
        this.addComment.next(true);
    }

    public onResolveStandStill(): void {
        this.resolveStandStill.next(true);
    }
}
